module.exports = __webpack_public_path__ + "assets/img/m_bdt_img3.367fa819.png";